import { render } from "./LikeShopItemImage.vue?vue&type=template&id=55638ad2&scoped=true"
import script from "./LikeShopItemImage.vue?vue&type=script&lang=js"
export * from "./LikeShopItemImage.vue?vue&type=script&lang=js"

import "./LikeShopItemImage.vue?vue&type=style&index=0&id=55638ad2&scoped=true&lang=postcss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55638ad2"]])

export default __exports__